import * as React from 'react';
import type { SVGProps } from 'react';
const SvgErrorOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 11.332a.646.646 0 0 0 .476-.192.642.642 0 0 0 .191-.475.646.646 0 0 0-.192-.475.642.642 0 0 0-.474-.191.646.646 0 0 0-.476.192.643.643 0 0 0-.191.474c0 .19.064.348.192.476a.642.642 0 0 0 .475.191Zm-.666-2.667h1.333v-4H7.334v4Zm.667 6a6.487 6.487 0 0 1-2.6-.525 6.743 6.743 0 0 1-2.117-1.425A6.728 6.728 0 0 1 1.859 10.6a6.503 6.503 0 0 1-.525-2.6c0-.923.175-1.79.525-2.6a6.743 6.743 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425A6.504 6.504 0 0 1 8 1.332c.922 0 1.789.175 2.6.525.81.35 1.516.825 2.116 1.425.6.6 1.075 1.306 1.426 2.117.35.81.525 1.677.524 2.6 0 .922-.175 1.789-.525 2.6a6.742 6.742 0 0 1-1.425 2.116c-.6.6-1.305 1.075-2.116 1.426a6.48 6.48 0 0 1-2.6.524Zm0-1.333c1.489 0 2.75-.517 3.783-1.55s1.55-2.294 1.55-3.783c0-1.49-.517-2.75-1.55-3.784-1.033-1.033-2.294-1.55-3.783-1.55-1.49 0-2.75.517-3.784 1.55C3.184 5.25 2.667 6.51 2.667 8c0 1.489.517 2.75 1.55 3.783 1.034 1.033 2.295 1.55 3.784 1.55Z" />
  </svg>
);
export default SvgErrorOutline;
